import React, { Component } from 'react';
import { Icon } from "@blueprintjs/core";
import {List, Map, fromJS} from "immutable";
import { connect } from 'react-redux';
import moment from "moment";
import {isFloat} from 'validator';

// Actions
import {getSuppliers} from "../../../actions/suppliers";

// Components
import Select from "../../../components/common/virtualized-select";
import StatusSelector from "../../../components/common/StatusSelector";
import { Link } from 'react-router-dom';

class ProductDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isActiveAddSupplier: false,
            selectedSupplier: {
                _id: -1,
                name: 'Selecciona un Proveedor'
            },
        };
    }

    render() {
        const { mode, product, onChangeInput,
            onChangeSupplierReference, onChangeDefaultSupplier, addSupplier, deleteSupplier,
            newCategoryLabel, addCategoryLabel, deleteCategoryLabel,
            suppliersList
        } = this.props;
        const { isActiveAddSupplier, selectedSupplier } = this.state;
        const booleanOptions = [{ value: true, name: 'Sí' }, { value: false, name: 'No' }];
        let formBody, filteredSuppliersList = List([]);

        suppliersList.map( supplierItem => {
            if(!product.suppliers.some(supplier => supplier.get('supplier_code') === supplierItem.get('supplier_code'))) {
                return filteredSuppliersList = filteredSuppliersList.insert(filteredSuppliersList.size, supplierItem);
            } else {
                return null
            }
        });

        let statusColor = '', statusText = '';

        switch (product.status) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        switch (mode) {
            case 'view':
                formBody = (
                    <div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código de Producto *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.product_code}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.name}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <label>Estado</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                        <StatusSelector
                                            statusObject={fromJS(product)}
                                            statusOptions={['active', 'inactive']}
                                            changeStatus={this.props.changeProductStatus}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label>Descripción</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.desc}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Etiquetas de categoría</label>
                                    <div style={{ height: 35 }} >
                                        { product.category_labels.map( (category, i) => {
                                            return <span key={i} className="badge badge-custom category-label">{category}</span>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Unidad de medida</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.unit_of_measure}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Tipo de IVA (%) *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.vat}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>¿Producto comprable?</label>
                                    <Select
                                        className="virtualized-select"
                                        options={booleanOptions}
                                        value={product.to_buy}
                                        labelKey="name"
                                        valueKey="value"
                                        matchProp="name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>¿Producto genérico?</label>
                                    <Select
                                        className="virtualized-select"
                                        options={booleanOptions}
                                        value={product.is_generic}
                                        labelKey="name"
                                        valueKey="value"
                                        matchProp="name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Seguimiento de precio
                            <Icon
                                icon="info-sign"
                                style={{ margin: '2px 6px' }}
                                title="Dispara una alerta cuando el precio de compra del producto supera el % máximo marcado respecto al anterior precio de compra registrado"
                            />
                        </h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>¿Alertar de aumento de precio?</label>
                                    <Select
                                        className="virtualized-select"
                                        options={booleanOptions}
                                        value={product.price_alert}
                                        labelKey="name"
                                        valueKey="value"
                                        matchProp="name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Porcentaje de aumento máximo (%)</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.price_alert_threshold}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        { product.to_buy
                            ? <div>
                                <div className="row" style={{ marginBottom: 15 }} >
                                    <div className="col d-flex justify-content-between">
                                        <h4>Proveedores</h4>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: 30 }}>
                                    <div className="col">{
                                        product.suppliers.size >= 1 ? (
                                            <div className="table-wrapper" >
                                                <div className="row table-header-row">
                                                    <div className="col-3">Nombre</div>
                                                    <div className="col-6">Referencia del proveedor</div>
                                                    <div className="col-2 d-flex justify-content-center">¿Proveedor de referencia?</div>
                                                </div>
                                                {
                                                    product.suppliers.map( (supplier, i) => {
                                                        return (
                                                            <div className="row table-row" key={i} >
                                                                <div className="col-3 d-flex align-items-center" style={{ fontSize: '0.9rem' }} >
                                                                    { supplier.get('name') }
                                                                    {/*{ supplier.getIn(['supplier', 'basic_info', 'name']) }*/}
                                                                </div>
                                                                <div className="col-6">
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={supplier.get('reference')}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                                <div className="col-2 d-flex justify-content-center align-items-center">
                                                                    { supplier.get('is_default') ? <Icon icon="tick"/> : null }
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        ) : 'No se ha añadido ningún proveedor para este producto.'
                                    }</div>
                                </div>
                                <h4>Precios de coste</h4>
                                <div className="row">
                                    <div className="col">{
                                        product.cost_prices && product.cost_prices.size > 0 ? (
                                            <table className="table">
                                                <thead>
                                                <tr>
                                                    <th>Pedido de compra</th>
                                                    <th>Fecha del pedido de compra</th>
                                                    <th>Proveedor</th>
                                                    <th style={{ textAlign: 'right' }} >Cantidad</th>
                                                    <th style={{ textAlign: 'right' }} >Precio unitario (€ sin impuestos)</th>
                                                    <th style={{ textAlign: 'right' }}>Descuento %</th>
                                                </tr>
                                                </thead>
                                                <tbody>{
                                                    product.cost_prices.map( (purchase_order, i) => {
                                                        return (
                                                            <tr key={i} >
                                                                <td style={{ fontSize: '0.9rem' }}>
                                                                    <Link to={`/compras/pedidos/${purchase_order.get('order_id')}`}>{ purchase_order.get('order_code') }</Link>
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem' }} >
                                                                    { moment(purchase_order.get('purchase_order_date')).format('DD/MM/YYYY') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem' }}>
                                                                    { purchase_order.get('supplier') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                                                                    { purchase_order.get('amount') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                                                                    { purchase_order.get('price') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                                                                    { purchase_order.get('discount') }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }</tbody>
                                            </table>
                                        ) : 'No se ha realizado ningún pedido de compra para este producto.'
                                    }
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                    </div>
                );
                break;
            case 'edit':
                formBody = (
                    <div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código de Producto *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.product_code}
                                        onChange={ (event) => onChangeInput('product_code', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.name}
                                        onChange={ (event) => onChangeInput('name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3 ml-auto">
                                <label>Estado del producto:</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label>Descripción</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.desc}
                                        onChange={ (event) => onChangeInput('desc', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Etiquetas de categoría</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={newCategoryLabel}
                                        onChange={ (event) => onChangeInput('newCategoryLabel', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-9" style={{ paddingTop: 25 }} >
                                <button
                                    className="btn btn-custom"
                                    style={{ marginRight: 5 }}
                                    disabled={ newCategoryLabel === ''}
                                    onClick={ () => addCategoryLabel() } >
                                    Añadir etiqueta
                                </button>
                                { product.category_labels.map( (category, i) => {
                                    return <span key={i} className="badge badge-custom category-label">
                                            {category}
                                        <Icon icon="cross" title="Eliminar" onClick={ () => deleteCategoryLabel(i) } />
                                        </span>
                                })}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Unidad de medida</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.unit_of_measure}
                                        onChange={ (event) => onChangeInput('unit_of_measure', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Tipo de IVA (%) *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.vat}
                                        onChange={ (event) => {
                                            const newValue = event.target.value;

                                            if ((isFloat(newValue) && newValue <= 100) || newValue === '') {
                                                onChangeInput('vat', newValue);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>¿Producto comprable?</label>
                                    <Select
                                        className="virtualized-select"
                                        options={booleanOptions}
                                        value={product.to_buy}
                                        labelKey="name"
                                        valueKey="value"
                                        matchProp="name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        onChange={(valueSelected) => {
                                            if (!valueSelected.value) {
                                                this.props.deleteSuppliers();
                                            }
                                            onChangeInput('to_buy', valueSelected.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>¿Producto genérico?</label>
                                    <Select
                                        className="virtualized-select"
                                        options={booleanOptions}
                                        value={product.is_generic}
                                        labelKey="name"
                                        valueKey="value"
                                        matchProp="name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        onChange={(valueSelected) => onChangeInput('is_generic', valueSelected.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <h4>Seguimiento de precio
                            <Icon
                                icon="info-sign"
                                style={{ margin: '2px 6px' }}
                                title="Dispara una alerta cuando el precio de compra del producto supera el % máximo marcado respecto al anterior precio de compra registrado"
                            />
                        </h4>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>¿Alertar de aumento de precio?</label>
                                    <Select
                                        className="virtualized-select"
                                        options={booleanOptions}
                                        value={product.price_alert}
                                        labelKey="name"
                                        valueKey="value"
                                        matchProp="name"
                                        multi={false}
                                        searchable={false}
                                        clearable={false}
                                        onChange={(valueSelected) => onChangeInput('price_alert', valueSelected.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Porcentaje de aumento máximo (%)</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={product.price_alert_threshold}
                                        onChange={ (event) => {
                                            const newValue = event.target.value;

                                            if (isFloat(newValue) || newValue === '') {
                                                onChangeInput('price_alert_threshold', newValue);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        { product.to_buy
                            ? <div>
                                <div className="row" style={{ marginBottom: 15 }} >
                                    <div className="col d-flex justify-content-between">
                                        <h4>Proveedores</h4>
                                        { isActiveAddSupplier
                                            ? (
                                                <div className="d-inline-flex justify-content-end">
                                                    <Select
                                                        className="virtualized-select"
                                                        style={{ width: 400, marginRight: 10 }}
                                                        options={filteredSuppliersList.toJS()}
                                                        value={selectedSupplier._id}
                                                        labelKey="name"
                                                        valueKey="_id"
                                                        matchProp="name"
                                                        multi={false}
                                                        searchable={true}
                                                        clearable={false}
                                                        onChange={ (valueSelected) => {
                                                            if (valueSelected) {
                                                                this.setState({ selectedSupplier: valueSelected });
                                                            }
                                                        }}
                                                    />
                                                    <button
                                                        className="btn btn-custom"
                                                        disabled={ selectedSupplier && selectedSupplier._id === -1 }
                                                        onClick={ () => {
                                                            addSupplier(selectedSupplier._id, selectedSupplier.basic_info.name, selectedSupplier.supplier_code);
                                                            this.setState({
                                                                selectedSupplier: {
                                                                    _id: -1,
                                                                    name: 'Selecciona un Proveedor'
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        Añadir
                                                    </button>
                                                </div>
                                            )
                                            : (
                                                <button
                                                    className="btn btn-custom"
                                                    onClick={ () => {
                                                        this.props.getSuppliers({
                                                            projection: 'supplier_code basic_info.name',
                                                            deleteVirtuals: true
                                                        });
                                                        this.setState({
                                                            isActiveAddSupplier: true
                                                        });
                                                    }}

                                                >
                                                    Añadir Proveedor
                                                </button>
                                            )

                                        }
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: 30 }} >
                                    <div className="col">{
                                        product.suppliers.size >= 1 ? (
                                            <div className="table-wrapper" >
                                                <div className="row table-header-row">
                                                    <div className="col-3">Nombre</div>
                                                    <div className="col-6">Referencia del proveedor</div>
                                                    <div className="col-2 d-flex justify-content-center">¿Proveedor de referencia?</div>
                                                </div>
                                                {
                                                    product.suppliers.map( (supplier, i) => {
                                                        return (
                                                            <div className="row table-row" key={i} >
                                                                <div className="col-3 d-flex align-items-center" style={{ fontSize: '0.9rem' }} >
                                                                    { supplier.get('name') }
                                                                </div>
                                                                <div className="col-6">
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={supplier.get('reference')}
                                                                        onChange={ (event) => onChangeSupplierReference(i, supplier, event.target.value) }
                                                                    />
                                                                </div>
                                                                <div className="col-2 d-flex justify-content-center align-items-center">
                                                                    <label className="radio-div">
                                                                        <input
                                                                            type="radio"
                                                                            checked={supplier.get('is_default')}
                                                                            onChange={ () => onChangeDefaultSupplier(supplier.get('is_default'), i) }
                                                                        />
                                                                        <span className="radio-btn"></span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-1 d-flex justify-content-center align-items-center">
                                                                    <Icon
                                                                        className="cursor-pointer"
                                                                        icon="trash"
                                                                        onClick={ () => deleteSupplier(i) }
                                                                    />
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        ) : 'No se ha añadido ningún proveedor para este producto.'
                                    }
                                    </div>
                                </div>
                                <h4>Precios de coste</h4>
                                <div className="row">
                                    <div className="col">{
                                        product.cost_prices && product.cost_prices.size > 0 ? (
                                            <table className="table">
                                                <thead>
                                                <tr>
                                                    <th>Pedido de compra</th>
                                                    <th>Fecha del pedido de compra</th>
                                                    <th>Proveedor</th>
                                                    <th style={{ textAlign: 'right' }} >Cantidad</th>
                                                    <th style={{ textAlign: 'right' }} >Precio unitario (€ sin impuestos)</th>
                                                    <th style={{ textAlign: 'right' }} >Descuento %</th>
                                                </tr>
                                                </thead>
                                                <tbody>{
                                                    product.cost_prices.map( (purchase_order, i) => {
                                                        return (
                                                            <tr key={i} >
                                                                <td style={{ fontSize: '0.9rem' }}>
                                                                    <Link to={`/compras/pedidos/${purchase_order.get('order_id')}`}>{ purchase_order.get('order_code') }</Link>
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem' }} >
                                                                    { moment(purchase_order.get('purchase_order_date')).format('DD/MM/YYYY') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem' }}>
                                                                    { purchase_order.get('supplier') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                                                                    { purchase_order.get('amount') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                                                                    { purchase_order.get('price') }
                                                                </td>
                                                                <td style={{ fontSize: '0.9rem', textAlign: 'right' }}>
                                                                    { purchase_order.get('discount') }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }</tbody>
                                            </table>
                                        ) : 'No se ha realizado ningún pedido de compra para este producto.'
                                    }
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                    </div>
                );
                break;
            default:
                formBody = null;
                break;
        }
        
        return formBody;
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const suppliersReducer = state.suppliers;

    // Suppliers
    const suppliers = suppliersReducer.get('payload') || List([]);
    let suppliersList = List([]);

    suppliersList = suppliersList.insert(suppliersList.size, Map({
        _id: -1,
        name: 'Selecciona un Proveedor'
    }));

    suppliers.size > 0 && suppliers.map( supplier => {
        return suppliersList = suppliersList.insert(suppliersList.size,
            supplier
                .set('name', `[${supplier.get('supplier_code')}] ${supplier.getIn(['basic_info','name'])}`)
        )
    });

    return {
        suppliersList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSuppliers: (query) => dispatch(getSuppliers(query))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);



// WEBPACK FOOTER //
// ./src/containers/configuration/products/ProductDetail.js